// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';
import data from './data/data.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1 : 9 / 16;
  const initialHeight = heightMultiplier * safeWidth;

  const props = { initialWidth: safeWidth, initialHeight, isMobile };

  const graphicConfig = config(props);
  graphic(graphicConfig, container, isMobile, data);
}


const trackedObjects = document.querySelectorAll('span');

// Main section of code that tracks the objects
window.pymChild.onMessage('viewport-iframe-position', (parentInfo) => {
  // this gets the parent position on the page
  const positions = parentInfo.split(' ').map(pos => parseFloat(pos));

  // check position and if on screen add in the inview class
  trackedObjects.forEach((obj) => {
    const tp = obj.getBoundingClientRect().top;
    if (tp > 0) {
      const tpos = 1 - ((tp + positions[2]) / positions[1]);

      // // ---- !!!!!!!! ---- ////
      // Must add in the fade class to the
      // objects after the check for position
      // if the position check fails then it wont hide them
      // and nothing is hidden on an error
      // by doing this afterwards we avoid that issue
      // // ---- !!!!!!!! ---- ////

      // add the fade class to the object
      obj.classList.add('tracked-object');

      // toggle the inview class based on position
      // obj.classList.toggle('inview', (tpos > 0.01));
      obj.classList.toggle('inview-highlight', (tpos > 0.3));
      // obj.classList.toggle('inview', (tpos > 0.2) & (tpos < 0.8));
    }
  });
});

// refresh to get the parent position info
setInterval(() => {
  window.pymChild.getParentPositionInfo();
  console.log('refresh successful');
}, 100);
